var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"btnExcel","dark":""},on:{"click":function($event){return _vm.handleDownload()}}},[_c('v-icon',[_vm._v("mdi-file-excel")]),_vm._v("Excel ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }